import isValidObjectID from "../../../../utils/isValidObjectID";

export const isGoalDetailsLink = (link: string) => {
	const linkParts = link.split("/");
	return !!(linkParts[1] === "goal" && isValidObjectID(linkParts[2]));
};

export const getGoalIdFromLink = (link: string, index = 0) => {
	let linkParts = link.split("/goal/");
	linkParts = linkParts[1].split("/");
	return linkParts[index];
};
export const formatStatus = (status: string) => {
	const normalizedStatus = status === "done" ? "completed" : status || "";
	return normalizedStatus.charAt(0).toUpperCase() + normalizedStatus.slice(1);
};

export const DEFAULT_BACKGROUND_COLOR = "#D8D8D8";
